module.exports = __webpack_public_path__ + "img/IMG_6689_L_Foamcore_MockedUp.faf2e16e.jpg";